module.exports = __webpack_public_path__ + "static/media/rib.fc737e46.png";